export const getCurrencyMockName = (currency) => {
  return `${currency.country} CBDC`
}
